import React, { useState, useEffect } from 'react';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import { fazerCheckin } from '../../services/api';

import Cookies from 'js-cookie';

import './MostrarDadosEstabelecimento.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/global.css';

const MostrarDadosEstabelecimento = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { estabelecimento } = location.state || {};

  const [dadosCheckin, setDadosCheckin] = useState({
    estabelecimento: estabelecimento,
    statusCheckin: 'usuarioNaoCheckado',
    objBarcheckin: {},
  });

  useEffect(() => {
    console.log('Estado atualizado - dadosCheckin:', dadosCheckin);
  }, [dadosCheckin]);


  const handleCheckinClick = async (e) => {
    e.preventDefault();

    console.log('---- ENTROU NO HANDLE CLICK CHECKIN ----');
    console.log('Fazendo Checkin... dadosCheckin:');
    console.log(dadosCheckin);

    try {
      const response = await fazerCheckin(dadosCheckin);
      const message = response.message;

      console.log('--------------------------------');
      console.log('Dados Checkin: ', response);
      console.log('--------------------------------');

      // Atualiza o estado para indicar que o usuário está checkado
      setDadosCheckin((prevState) => ({
        ...prevState,
        statusCheckin: 'usuarioCheckado'
      }));

      console.log('Usuário checkado com sucesso!');
      console.log('objBarcheckin: ');
      console.log(response.objBarcheckin);
      console.log('estabelecimento: ');
      console.log(dadosCheckin.estabelecimento);
      
      // Armazena os dados do check-in na sessão
      sessionStorage.setItem('dadosCheckin', JSON.stringify({
        estabelecimento: dadosCheckin.estabelecimento,
        objBarcheckin: response.objBarcheckin,
        statusCheckin: 'usuarioCheckado'
      }));

      // armazena os dados nos cookies
      const date = new Date();
      date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 dias
      
      Cookies.set('dadosCheckin', JSON.stringify({
        estabelecimento: dadosCheckin.estabelecimento,
        objBarcheckin: response.objBarcheckin,
        statusCheckin: 'usuarioCheckado'
      }), { expires: date });
      
      alert(message);

      navigate('/');
      
    } catch (error) {
      console.error('Erro ao fazer check-in:', error);
      const errorMessage = error.response?.data?.message ?? 'Erro ao fazer check-in. Tente novamente.';

      // Armazena os dados do check-in na sessão
      sessionStorage.setItem('dadosCheckin', JSON.stringify({
        estabelecimento: dadosCheckin.estabelecimento,
        statusCheckin: 'usuarioNaoCheckado'
      }));

      alert(errorMessage);
    }
  };

  return (
    <div className="mostrar-dados-container">
      <TituloComponent />
      <div className="content">

        <div className="quadro-mostrar-dados-estabelecimento" >

          <h1 className="sub-titulo">{estabelecimento.nome}</h1>

          {/* <h3>Sobre o Estabelecimento</h3> */}
            {estabelecimento ? (
              <div>
                <p><strong>Fone fixo:</strong> {estabelecimento.telefone_fixo}</p>
                <p><strong>Celular:</strong> {estabelecimento.telefone_celular}</p>
                {/* <p><strong>Latitude:</strong> {estabelecimento.latitude}</p>
                <p><strong>Longitude:</strong> {estabelecimento.longitude}</p> */}
              </div>
            ) : (
              <p>Dados não carregados.</p>
            )}
        </div>


        <div className="quadro" onClick={handleCheckinClick}>
          <h3>Fazer Checkin</h3>
          <p>Clique para fazer seu checkin.</p>
        </div>

      </div>
    </div>
  );
};

export default MostrarDadosEstabelecimento;